import { render, staticRenderFns } from "./treatrecordStore.vue?vue&type=template&id=273a5894"
import script from "./treatrecordStore.vue?vue&type=script&lang=js"
export * from "./treatrecordStore.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/code/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('273a5894')) {
      api.createRecord('273a5894', component.options)
    } else {
      api.reload('273a5894', component.options)
    }
    module.hot.accept("./treatrecordStore.vue?vue&type=template&id=273a5894", function () {
      api.rerender('273a5894', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/therapy/treatrecordStore.vue"
export default component.exports